<div class="vz vz-app" [class.vz-app--open]="navOpen()">
    <!-- Kolumna nawigacji (< 980 px — wysuwany panel) -->
    <aside class="vz-side" id="vz-nav" [attr.aria-label]="'nav.label' | t">
        <div class="vz-logo">
            <img class="vz-logo__wm" src="images/vazuvi/logo.svg" alt="VAZUVI" width="128" height="31" />
            <span class="vz-bynex">by <img src="images/vazuvi/by-nex1.png" alt="NEX1" width="34" height="8" /></span>
            <button #navClose type="button" class="vz-ib vz-logo__x" (click)="closeNav()" [attr.aria-label]="'nav.close' | t">
                <vz-icon name="x" />
            </button>
        </div>

        <div class="vz-who">
            <div class="vz-av">{{ clientInitials() }}</div>
            <strong>{{ clientName() }}</strong>
            <small>{{ (clientMode ? 'account.adminView' : 'account.clientAccount') | t }}</small>
        </div>

        <!-- Filtr firmy (Issue 26): konto z firmami powiązanymi; wybór zapamiętany w adresie (?firma=) -->
        @if (multiCompany()) {
            <div class="vz-firms" role="group" [attr.aria-label]="'account.companiesFilter' | t">
                <button type="button" class="vz-firm" [class.vz-firm--on]="company() === null" [attr.aria-pressed]="company() === null" (click)="pickCompany(null)">
                    {{ 'account.allCompanies' | t }}
                </button>
                @for (c of companies(); track c.clientId) {
                    <button type="button" class="vz-firm" [class.vz-firm--on]="company() === c.clientId" [attr.aria-pressed]="company() === c.clientId" [attr.title]="c.name" (click)="pickCompany(c.clientId)">
                        {{ c.shortName }}
                    </button>
                }
            </div>
        }

        <nav class="vz-nav" [attr.aria-label]="'nav.label' | t">
            <a class="vz-ni" routerLink="/" routerLinkActive="vz-ni--on" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page">
                <vz-icon name="home" /><span>{{ 'nav.home' | t }}</span>
            </a>
            <a class="vz-ni" routerLink="/sprawy" routerLinkActive="vz-ni--on" ariaCurrentWhenActive="page">
                <vz-icon name="folder" /><span>{{ 'nav.cases' | t }}</span>
                @if (casesWaiting(); as n) {
                    <span class="vz-ni__bd" [attr.title]="'nav.casesBadge' | t: { n }" role="img" [attr.aria-label]="'nav.casesBadge' | t: { n }">{{ n }}</span>
                }
            </a>
            <a class="vz-ni" routerLink="/pojazdy" routerLinkActive="vz-ni--on" ariaCurrentWhenActive="page">
                <vz-icon name="car" /><span>{{ 'nav.vehicles' | t }}</span>
            </a>
            <a class="vz-ni" routerLink="/polisy" routerLinkActive="vz-ni--on" ariaCurrentWhenActive="page">
                <vz-icon name="shield" /><span>{{ 'nav.policies' | t }}</span>
                @if (policiesEnding()) {
                    <span class="vz-ni__dot" [attr.title]="'nav.policiesDot' | t" role="img" [attr.aria-label]="'nav.policiesDot' | t"></span>
                }
            </a>
            <a class="vz-ni" routerLink="/finansowanie" routerLinkActive="vz-ni--on" ariaCurrentWhenActive="page">
                <vz-icon name="cash" /><span>{{ 'nav.financing' | t }}</span>
            </a>
            <a class="vz-ni" routerLink="/dokumenty" routerLinkActive="vz-ni--on" ariaCurrentWhenActive="page">
                <vz-icon name="doc" /><span>{{ 'nav.documents' | t }}</span>
            </a>
            <!-- „Załatw sprawę” (Issue 40, D25): jedno wejście do zgłoszeń i nowego zakupu -->
            <a class="vz-btn vz-btn--action vz-nav__new" routerLink="/zgloszenia/nowe"><vz-icon name="plus" size="s" />{{ 'nav.newTicket' | t }}</a>
        </nav>

        <!-- Karta opiekuna: rozwija telefon, „Zadzwoń” (tel:) i „Napisz” (e-mail — D18); bez kontaktu się nie rozwija -->
        @if (advisor(); as a) {
            <ng-template #advisorWho>
                <span class="vz-av vz-av--op">{{ advisorInitials() }}</span>
                <span class="vz-op__who">
                    <strong>{{ a.name }}</strong>
                    <small>{{ a.salutation }}</small>
                </span>
            </ng-template>
            <div class="vz-sidefoot">
                <div class="vz-op" [class.vz-op--open]="advisorOpen()">
                    @if (a.phone || a.email) {
                        <button
                            type="button"
                            class="vz-op__h"
                            (click)="advisorOpen.set(!advisorOpen())"
                            [attr.aria-expanded]="advisorOpen()"
                            aria-controls="vz-op-body"
                        >
                            <ng-container [ngTemplateOutlet]="advisorWho" />
                            <vz-icon [name]="advisorOpen() ? 'chevd' : 'chev'" size="s" />
                        </button>
                    } @else {
                        <div class="vz-op__h">
                            <ng-container [ngTemplateOutlet]="advisorWho" />
                        </div>
                    }
                    @if (advisorOpen() && (a.phone || a.email)) {
                        <div class="vz-op__b" id="vz-op-body">
                            @if (a.phone) {
                                <span class="vz-op__tel vz-num"><vz-icon name="phone" size="s" /><span>{{ a.phone | vzPhone }}</span></span>
                            }
                            <div class="vz-op__acts">
                                @if (a.phone) {
                                    <a class="vz-btn vz-btn--secondary vz-btn--sm" [href]="advisorTel()">
                                        <vz-icon name="phone" size="s" />{{ 'advisor.call' | t }}
                                    </a>
                                }
                                @if (a.email) {
                                    <a class="vz-btn vz-btn--secondary vz-btn--sm" [href]="'mailto:' + a.email">
                                        <vz-icon name="chat" size="s" />{{ 'advisor.write' | t }}
                                    </a>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </aside>

    <div class="vz-scrim" (click)="closeNav()" aria-hidden="true"></div>

    <div class="vz-main">
        <header class="vz-bar">
            <button
                #hamburger
                type="button"
                class="vz-ib vz-bar__hamb"
                (click)="openNav()"
                [attr.aria-label]="'nav.open' | t"
                aria-controls="vz-nav"
                [attr.aria-expanded]="navOpen()"
            >
                <vz-icon name="bars" />
            </button>

            @if (features.search) {
                <vz-global-search (opened)="popover.set(null)" />
            } @else {
                <div class="vz-bar__sp"></div>
            }

            @if (features.events) {
                <button
                    type="button"
                    class="vz-ib vz-bell"
                    data-popover-trigger
                    (click)="togglePopover('bell')"
                    aria-haspopup="dialog"
                    [attr.aria-expanded]="popover() === 'bell'"
                    [attr.aria-label]="freshEvents() ? ('bell.label' | t) + ' — ' + ('bell.dot' | t) : ('bell.label' | t)"
                >
                    <vz-icon name="bell" />
                    @if (freshEvents()) {
                        <span class="vz-bell__dot" aria-hidden="true"></span>
                    }
                </button>
            }

            <button
                type="button"
                class="vz-me"
                data-popover-trigger
                (click)="togglePopover('account')"
                aria-haspopup="menu"
                [attr.aria-expanded]="popover() === 'account'"
            >
                <!-- Inicjały to awatar — nazwą przycisku jest „Konto” (WCAG 2.5.3: widoczny tekst nie przeczy nazwie) -->
                <span class="vz-me__avatar" aria-hidden="true">{{ clientInitials() }}</span>
                <span class="vz-sr">{{ 'account.label' | t }}</span>
            </button>

            @if (popover() === 'bell') {
                <div class="vz-pop vz-pop--bell" role="dialog" [attr.aria-label]="'bell.title' | t">
                    <div class="vz-pop__h">
                        <vz-icon name="bell" size="s" />
                        <strong>{{ 'bell.title' | t }}</strong>
                        @if (freshEvents(); as n) {
                            <span class="vz-pop__new">{{ 'bell.newCount' | t: { n } }}</span>
                        }
                    </div>
                    @for (e of bellEvents(); track e.id) {
                        <a class="vz-pop__ev" [routerLink]="link(e)" [queryParams]="query(e)">
                            <span class="vz-fe__ico" [class.vz-fe__ico--client]="e.kind === 'client'" [class.vz-fe__ico--info]="e.kind === 'info'" aria-hidden="true">
                                @if (e.kind === 'client') {
                                    <b>!</b>
                                } @else if (e.kind === 'info') {
                                    <b>×</b>
                                } @else {
                                    <vz-icon name="check" size="s" />
                                }
                            </span>
                            <span class="vz-pop__evt">
                                <span class="vz-pop__evp">
                                    @if (e.caseTitle) {
                                        <b>{{ e.caseTitle }}</b> ·
                                    }
                                    {{ e.stageName }}: {{ e.label }} <vz-owner [owner]="e.owner" />
                                </span>
                                <small>{{ e.at | vzWhen }}</small>
                            </span>
                        </a>
                    } @empty {
                        <p class="vz-pop__empty">{{ 'bell.empty' | t }}</p>
                    }
                    <a class="vz-pop__all" routerLink="/sprawy">{{ 'bell.all' | t }} <vz-icon name="chev" size="xs" /></a>
                </div>
            }

            @if (popover() === 'account') {
                <div class="vz-pop vz-pop--account" role="menu" [attr.aria-label]="'account.label' | t">
                    <div class="vz-pop__acct">
                        <span class="vz-av">{{ clientInitials() }}</span>
                        <span>
                            <strong>{{ clientName() }}</strong>
                            @if (relatedCount(); as n) {
                                <small>{{ 'account.relatedCompanies' | t: { n } }}</small>
                            } @else {
                                <small>{{ (clientMode ? 'account.adminView' : 'account.clientAccount') | t }}</small>
                            }
                        </span>
                    </div>
                    @if (relatedCount()) {
                        <ul class="vz-pop__firms">
                            @for (c of companies(); track c.clientId) {
                                <li>{{ c.name }} <small>{{ (c.relation === 'own' ? 'account.ownCompany' : 'account.relatedCompany') | t }}</small></li>
                            }
                        </ul>
                    }
                    <a class="vz-pop__row" role="menuitem" routerLink="/konto">
                        <vz-icon name="user" size="s" /><span>{{ 'account.details' | t }}</span>
                    </a>
                    @if (clientMode) {
                        <button type="button" class="vz-pop__row" role="menuitem" (click)="exitClientMode()">
                            <vz-icon name="back" size="s" /><span>{{ 'account.exitClientMode' | t }}</span>
                        </button>
                    }
                    <a class="vz-pop__row" role="menuitem" routerLink="/wylogowano">
                        <vz-icon name="key" size="s" /><span>{{ 'account.signOut' | t }}</span>
                    </a>
                </div>
            }
        </header>

        <main class="vz-view">
            <router-outlet />
        </main>
    </div>
</div>
